import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import "./styles.scss";
import PageHeader from "../../common/pageHeader";
import ColorSkinWrapper from "../../common/colorSkinWrapper";
import { actions as bookmakersInfoActions } from "../../common/bookmakersInfo";
import { selectors as transitionRouterSelectors } from "../../common/transitionRouter";
import {
	selectors as bookmakersListSelectors,
	actions as bookmakersListActions,
} from "../../common/bookmakersList";
import UserInfo, { selectors as userInfoSelectors } from "../../common/userInfo";
import { actions as externalAccountActions } from "../../common/externalAccount";
import Tabs from "./components/Tabs";
import BetHistory from "./components/betHistory";
import AccountInfo from "./components/accountInfo";

export const Account = ({
	name,
	feed,
	userInfo,
	showBalance,
	hasAccountTabs,
	hasLogoOnAccountHeader,
	toggleBalanceVisibility,
}) => (
	<ColorSkinWrapper
		bookmakerName={name}
		className={`bs-popover__content
                            bs-switchBookmakers__content
                            bs-horizontalSlider__element`}
	>
		<PageHeader hideLogo={!hasLogoOnAccountHeader} backLinkUrl='/'>
			<UserInfo
				{...userInfo}
				showBalance={showBalance}
				toggleBalanceVisibility={toggleBalanceVisibility}
				selectedBookmakerFeed={feed}
			/>
		</PageHeader>
		{hasAccountTabs && <Tabs feed={feed} />}
		<Route path='/:feed/account/info' component={AccountInfo} />
		<Route path='/:feed/account/bethistory' component={BetHistory} />
	</ColorSkinWrapper>
);

Account.defaultProps = {
	hasLogoOnAccountHeader: false,
	hasAccountTabs: true,
	apiName: "",
};

Account.propTypes = {
	name: PropTypes.string.isRequired,
	userInfo: PropTypes.shape({
		hasDetails: PropTypes.bool,
		name: PropTypes.string,
		balance: PropTypes.number.isRequired,
		currencySign: PropTypes.string.isRequired,
	}).isRequired,
	feed: PropTypes.string.isRequired,
	hasLogoOnAccountHeader: PropTypes.bool,
	hasAccountTabs: PropTypes.bool,
	apiName: PropTypes.string,
	showBalance: PropTypes.bool.isRequired,
	toggleBalanceVisibility: PropTypes.func.isRequired,
	clearExternalAccountData: PropTypes.func.isRequired,
	setLoggedOut: PropTypes.func.isRequired,
	getUserInfo: PropTypes.func.isRequired,
};

const userInfoSelector = userInfoSelectors.createUserInfoSelector(
	transitionRouterSelectors.feedSelector
);

const bookmakerInfoSelector = bookmakersListSelectors.createBookmakerInfoSelector(
	transitionRouterSelectors.feedSelector
);

const showBalanceSelector = userInfoSelectors.createShowBalanceSelector(
	transitionRouterSelectors.feedSelector
);

const mapStateToProps = (state, props) => ({
	...bookmakerInfoSelector(state, props),
	feed: transitionRouterSelectors.feedSelector(state, props),
	userInfo: userInfoSelector(state, props),
	showBalance: showBalanceSelector(state, props),
});

const mapDispatchToProps = {
	toggleBalanceVisibility: bookmakersInfoActions.toggleBalanceVisibility,
	clearExternalAccountData: externalAccountActions.clearExternalAccountData,
	setLoggedOut: bookmakersListActions.setLoggedOut,
	getUserInfo: bookmakersListActions.getUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/Account.jsx